export const Wholesaler = {
    path: '/wholesalers',
    name: 'wholesalers',
    component: () => import('@/views/Customer/WholesalerPage.vue'),
    children: [
        {
            path: '/wholesalers/add',
            name: 'wholesalers.add',
            component: () => import('@/views/Customer/Form/CustomerForm.vue'),
            props: {addAction: true, type: 'wholesaler'}
        },
        {
            path: '/wholesalers/edit/:id',
            name: 'wholesalers.edit',
            component: () => import('@/views/Customer/Form/CustomerForm.vue'),
            props: {updateAction: true, type: 'wholesaler'}
        },
        {
            path: '/wholesalers/delete/:id',
            name: 'wholesalers.delete',
            component: () => import('@/views/Customer/Form/CustomerForm.vue'),
            props: {deleteAction: true, type: 'wholesaler'}
        },
        {
            path: '/wholesalers/view/:id',
            name: 'wholesalers.view',
            component: () => import('@/views/Customer/Form/CustomerForm.vue'),
            props: {viewAction: true, type: 'wholesaler'}
        },
        {
            path: '/wholesalers/tour_plan/add/:customerId',
            name: 'wholesalers.tour_plan.add',
            component: () => import('@/views/TourPlan/Form/TourPlanForm.vue'),
            props: {addAction: true},
        },
        {
            path: '/wholesalers/visit/add/:customerId',
            name: 'wholesalers.visit.add',
            component: () => import('@/views/Visit/Form/VisitForm.vue'),
            props: {addAction: true, type: 'wholesaler'},
        },
        {
            path: '/wholesalers/visit/edit/:id',
            name: 'wholesalers.visit.edit',
            component: () => import('@/views/Visit/Form/VisitForm.vue'),
            props: {updateAction: true, type: 'wholesaler'},
        },
        {
            path: '/wholesalers/visit/delete/:id',
            name: 'wholesalers.visit.delete',
            component: () => import('@/views/Visit/Form/VisitForm.vue'),
            props: {deleteAction: true, type: 'wholesaler'},
        },
        {
            path: '/wholesalers/visit/view/:id',
            name: 'wholesalers.visit.view',
            component: () => import('@/views/Visit/Form/VisitForm.vue'),
            props: {viewAction: true, type: 'wholesaler'},
        },
    ]
}